import React from 'react';
import MaterialTable from '@mui/material/Table';
import type {TableProps as MaterialTableProps} from '@mui/material/Table';
import {styled} from '@mui/material/styles';
import {excludeComponentProps} from '../utils/excludeComponentProps';

type BaseTableProps = Omit<MaterialTableProps, 'padding'>;

export interface TableProps extends BaseTableProps {
    /**
     * Adds zebra-striping to any table row within the `tbody`.
     */
    striped?: boolean;
}

const StyledTable = styled(MaterialTable, {
    ...excludeComponentProps('striped')
})<TableProps>(({
    theme, striped, size: currentSize
}) => {
    const size = currentSize && ['small', 'medium', 'large'].includes(currentSize) ? currentSize : 'medium';

    return {
        ...striped && {
            '.MuiTableBody-root .MuiTableRow-root:nth-of-type(2n)': {
                backgroundColor: theme.tokens.FuelColorGray100,
                '&:hover': {
                    backgroundColor: theme.tokens.FuelColorGray50
                }
            }
        },
        ...size === 'small' && {
            minHeight: '2rem',
            fontSize: theme.tokens.FuelFontSizeSm,
            padding: `${theme.tokens.FuelSpacing4} ${theme.tokens.FuelSpacing3}`
        },
        '&.MuiTable-stickyHeader': {
            borderCollapse: 'collapse'
        }
    };
});

export const Table = React.forwardRef<any, TableProps>(({
    children, striped, ...props
},
ref
) => (
    <StyledTable
        ref={ref}
        striped={striped}
        {...props}
    >
        {children}
    </StyledTable>
));

Table.displayName = 'Table';
